<template>
  <div class="mx-auto">
    <v-card flat class="pa-2">
      <v-container class="pa-5">
        <base-form-generator :schema="schema" v-model="form" />
        <v-spacer />
        <div>
          <h4>Pilih Sekolah</h4>
          <v-alert class="my-2" color="blue" text>
            <v-row>
              <v-col class="grow">
                <div class="black--text">
                  Silakan pilih <b>(minimal 1, maksimal 20)</b> sekolah yang ingin dijadikan Anggota Kelompok
                </div>
              </v-col>
              <v-col class="shrink">
                <v-btn class="success" depressed @click="onPilihSekolah">
                  <v-icon left>mdi-hospital-building</v-icon>
                  Pilih Sekolah
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </div>
        <template v-if="sekolah.length">
          <div>
            <span class="blue--text">{{ sekolah.length }}</span> Sekolah Terpilih
          </div>
          <v-spacer />
          <v-row v-for="(item, i) in sekolah" :key="item.sekolah_id">
            <v-col cols="12" md="6" sm="12">
              <v-list-item class="px-0">
                <v-list-item-avatar color="blue">
                  <v-icon dark>mdi-hospital-building</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0 px-1">
                  <div class="blue--text">
                    {{
                      $getDeepObj(item, 'nama') ||
                        $getDeepObj(item, 'sekolah.data.nama') ||
                        $getDeepObj(item, 'sekolah.nama') ||
                        '-'
                    }}
                  </div>
                  <div class="black--text"
                    ><b>NPSN : </b>
                    {{
                      $getDeepObj(item, 'npsn') ||
                        $getDeepObj(item, 'sekolah.data.sekolah_id') ||
                        $getDeepObj(item, 'sekolah.sekolah_id') ||
                        '-'
                    }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="3" sm="12">
              <v-list-item class="px-0">
                <v-list-item-content class="py-0">
                  <v-list-item-title>
                    <v-label color="caption"><small>Alamat Sekolah </small></v-label>
                  </v-list-item-title>
                  <div class="link black--text body-2">
                    {{
                      $getDeepObj(item, 'alamat') ||
                        $getDeepObj(item, 'sekolah.data.alamat') ||
                        $getDeepObj(item, 'sekolah.alamat') ||
                        '-'
                    }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="1" sm="1">
              <div class="mt-2" />
              <v-btn icon color="red" @click="onDelete(i)"><v-icon>mdi-close-circle</v-icon></v-btn>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-card>
    <sumber ref="kandidat" title="Pilih Sekolah" :api="`${jenis === 'kp' ? 'diklatDkp' : 'diklatPa'}/getKandidat`" />
  </div>
</template>
<script>
import Sumber from './Sumber';
import BaseFormGenerator from '../../../../../components/base/BaseFormGenerator';
export default {
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    jenis: {
      type: String,
      default: 'kp',
    },
  },
  components: { BaseFormGenerator, Sumber },
  data() {
    return {
      form: {},
      sekolah: [],
    };
  },
  computed: {
    schema() {
      return [
        {
          type: 'VTextField',
          name: 'nama',
          label: `Nama Kelompok Pendampingan ${this.jenis === 'kp' ? 'KP' : 'PA'}`,
          labelColor: 'secondary',
          hint: 'wajib diisi',
          required: true,
          grid: { cols: 12 },
          outlined: true,
          singleLine: true,
        },
      ];
    },
  },
  methods: {
    initForm(value) {
      if (!value) return;
      this.$set(this.form, 'nama', this.$getDeepObj(value, 'nama') || '');
      this.sekolah =
        this.$getDeepObj(value, `psp_${this.jenis}_sekolahs.data`) ||
        this.$getDeepObj(value, `psp_${this.jenis}_sekolahs`) ||
        [];
    },

    reset() {
      this.$set(this, 'form', {});
      this.$set(this, 'sekolah', []);
    },

    getValue() {
      let form = this.form;
      let sekolah = [];
      this.sekolah.forEach((item) => {
        sekolah.push(item.sekolah_id);
      });

      form['sekolah'] = sekolah;

      return {
        form: form,
      };
    },

    onPilihSekolah() {
      const sekolah = [...this.sekolah].map((key) => key.sekolah_id);
      const fields = [
        {
          key: 'nama',
          icon: 'mdi-hospital-building',
          title: '',
          list: [
            {
              key: 'nama',
              class: 'body-1 blue--text',
            },
            {
              key: 'npsn',
              label: 'NPSN: ',
              class: 'body-2 black--text font-weight-medium',
            },
            {
              key: 'alamat',
              class: 'black--text',
            },
          ],
        },
      ];
      this.$refs.kandidat.open(fields, sekolah).then((resp) => {
        resp.forEach((item) => {
          this.sekolah.push(item);
        });
      });
    },

    validate() {
      let status = true;
      if (this.sekolah.length < 1 || this.sekolah.length > 20) {
        this.$error('Sekolah hanya bisa dipilih minimal 1 dan maksimal 20');
        status = false;
      }
      return status;
    },

    onDelete(index) {
      this.sekolah.splice(index, 1);
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
